import React, { useMemo } from "react";
import { Routes, Route } from "react-router-dom";

import { SnackbarProvider } from "notistack";

import "./App.css";

import ChatWindow from "./components/ChatWindow";
import LandingPage from "./components/LandingPage";
// partner chnage 
function App(props = {}) {
  const urlParams = new URLSearchParams(window.location.search);
  const partnerIdFromUrl = urlParams.get("uniquePartnerId") || urlParams.get("partnerId");
  const partnerIdFromWindow = window.DexkorConfig?.uniquePartnerId || window.uniquePartnerId;

  let resolvedPartnerId = partnerIdFromUrl || partnerIdFromWindow;

  const currentHost = window.location.hostname;

  if (!resolvedPartnerId) {
    if (currentHost.includes("widget.dexkor.com") || currentHost === "localhost" || currentHost === "127.0.0.1") {
      // resolvedPartnerId = "66f3bb71351367d757b6550b";
      // resolvedPartnerId = "6a1eae636c6520e0074958ec";
      // resolvedPartnerId = "66f7d1662ea86574e070c536";
      resolvedPartnerId = "6ad1d4528a43ce2dc2051312";
    } else {
      console.error("Please pass partnerId");
    }
  }

  // Support either userEmail or email: consider either as userEmail and pass as prop
  const userEmail =
    props?.userEmail ||
    props?.email ||
    urlParams.get("userEmail") ||
    urlParams.get("email") ||
    window.DexkorConfig?.userEmail ||
    window.DexkorConfig?.email ||
    window.userEmail ||
    window.email;

  const config = useMemo(
    () => ({
      ...props,
      hostUrl: window.location.origin, // Capture and send the host URL
      uniquePartnerId: resolvedPartnerId,
      ...(userEmail ? { userEmail } : {}),

          // hideLauncher: "hidden"

    // uniquePartnerId: "66f7d1662ea86574e070c536",
    // dexkorId:"66f7d1662ea86574e070c536",
    // customerCode: "Radha-001",
    // userName: "Ravindra Kumar",
    // userNumber: "9648316865",
    // application:true,
    // userEmail:"richard@dexkor.com",
    // userId:"6905bf6bb1eb2947a75e00c4"

    //  added unique partner id


    }),
    [props, resolvedPartnerId, userEmail]
  );
  return (
    <SnackbarProvider anchorOrigin={{ vertical: "top", horizontal: "right" }}>
      <div className="dexkor-app zoom-reset" id="main-content">
        <LandingPage />
        <Routes>
          <Route path="/" element={<ChatWindow {...config} />} />
        </Routes>
      </div>
    </SnackbarProvider>
  );
}

export default App;
